import { AWS_API_URL } from 'global/environment';
import { authorize, getRequest } from 'utils/http';

const url = `${AWS_API_URL}/laundry/sso-link`;

export async function getLaundryLinkAPI() {
  return getRequest(url, await authorize());
}
